// import * as R from 'ramda';
// import initialState from "./initialState";
// export const resetState  = (state) => {
//   const clonedState=R.clone(initialState);
//   Object.keys(clonedState).forEach(key => { state[key] = clonedState[key] });
// };

function log_view(state) {

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
            items: [state.gtmItem]
        }
    });
}


export const mutateCounter = (state, incrementor) => {
    state.counter = state.counter + incrementor;
};


export const setCurrentVariantId = (state, id) => {
    state.currentVariantId = id;
    state.currentVariant=state.variants.find(i => i.id === id);
    state.gtmItem.item_id = state.currentVariantId;
    state.gtmItem.item_variant = state.currentVariant.name;
    state.gtmItem.price = state.currentVariant.pricestr;
    document.body.id = `variant-${id}`;
    log_view(state);
};

export const setCustomPrice = (state, val) => {
    state.customPrice = val;
};


export const setActiveImageIndex = (state, val) => {
    state.activeImageIndex = val;
};

export const setVariants = (state, val) => {
    state.variants = val;
    generateGtmItem(state);
};

function generateGtmItem(state) {
    state.gtmItem={...state.extconf.itemdata}
}

export const setImages = (state, val) => {
    state.images = val;
};
